var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"403","title":"403","subTitle":_vm.$t('common_341')},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"}},[_c('auto-router-link',{attrs:{"text":_vm.$t('common_342')}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }